import React from 'react';

export function Skeleton({ children, component: SkeletonComponent, isEmptyState, loading, ...rest }) {
  return loading || isEmptyState ? <SkeletonComponent {...rest} /> : children;
}
